export default function customForms(options = {}) {
	const { block } = options;

	const container = block.querySelector(".cdb_form_input_container");
	const formEl =
		container?.querySelector("form") ||
		block.querySelector("form.competition_form");

	const searchRoot = container ?? block;

	if (formEl) {
		formEl.setAttribute("novalidate", "true");

		formEl.addEventListener("submit", (e) => {
			if (formEl.checkValidity()) return;

			e.preventDefault();

			requestAnimationFrame(() => {
				const firstInvalid = searchRoot.querySelector(
					".cdb_form_field.invalid, ._block_optin.invalid, ._block_terms.invalid",
				);

				if (firstInvalid) {
					firstInvalid.scrollIntoView({
						behavior: "smooth",
						block: "center",
					});

					const field = firstInvalid.querySelector(
						"input, select, textarea",
					);
					field?.focus({ preventScroll: true });
				}
			});
		});

		formEl.addEventListener(
			"invalid",
			(e) => {
				e.preventDefault();

				if (container?.hasAttribute("data-suppress-invalid")) return;

				const target = e.target;
				if (!(target instanceof HTMLElement)) return;

				const wrap =
					target.closest(".cdb_form_field") ||
					target.closest("._block_optin") ||
					target.closest("._block_terms") ||
					target.closest(".cdb_form_privacypolicy_information");
				if (wrap) wrap.classList.add("invalid");
			},
			true,
		);

		searchRoot
			.querySelectorAll(
				"._block_optin input[type=checkbox], ._block_terms input[type=checkbox], .cdb_form_privacypolicy_information input[type=checkbox]",
			)
			.forEach((cb) => {
				cb.addEventListener("change", () => {
					if (cb.checked) {
						cb.closest(
							"._block_optin, ._block_terms, .cdb_form_privacypolicy_information",
						)?.classList.remove("invalid");
					}
				});
			});
	}

	block
		.querySelectorAll(
			"._block_country_for_optin, ._block_country_select, ._block_intelex_lot_code, ._block_intelex_brand, ._block_intelex_complaint_type, ._block_intelex_product, ._block_intelex_country",
		)
		.forEach((wrapper) => {
			const select = wrapper.querySelector("select");
			if (!select) return;

			if (select.dataset.enhanced) return;
			select.dataset.enhanced = "true";

			const label = wrapper.querySelector("label[data-title]");
			const titleText = label?.getAttribute("data-title") || "";

			const options = [...select.options];

			const customSelect = document.createElement("div");
			customSelect.className = "custom-select";
			customSelect.setAttribute("title", titleText);

			const selected = document.createElement("span");
			selected.className = "custom-selected";
			selected.textContent =
				select.options[select.selectedIndex]?.text || "Select…";
			if (!select.value) selected.classList.add("is-placeholder");
			customSelect.appendChild(selected);

			const optionList = document.createElement("div");
			optionList.className = "custom-options";

			options.forEach((opt) => {
				const optionDiv = document.createElement("div");
				optionDiv.className = "custom-option";
				optionDiv.textContent = opt.text
					.toLowerCase()
					.replace(/\b\w/g, (c) => c.toUpperCase());
				optionDiv.dataset.value = opt.value;

				optionDiv.addEventListener("click", (e) => {
					e.stopPropagation();

					select.value = opt.value;

					selected.textContent = opt.text;
					optionList.classList.remove("open");
					customSelect.classList.remove("open");
					wrapper.classList.remove("focused");

					if (!opt.value) {
						selected.classList.add("is-placeholder");
						select.setCustomValidity("This field is required");
					} else {
						selected.classList.remove("is-placeholder");
						select.setCustomValidity("");
						wrapper.classList.remove("invalid");
					}

					select.dispatchEvent(new Event("input", { bubbles: true }));
					select.dispatchEvent(
						new Event("change", { bubbles: true }),
					);
				});

				optionList.appendChild(optionDiv);
			});

			customSelect.appendChild(optionList);
			wrapper.appendChild(customSelect);

			selected.addEventListener("click", (e) => {
				e.stopPropagation();
				document
					.querySelectorAll(".custom-options.open")
					.forEach((list) => {
						if (list !== optionList) {
							list.classList.remove("open");
							list.closest(".custom-select")?.classList.remove(
								"open",
							);
						}
					});
				const isOpen = optionList.classList.toggle("open");
				customSelect.classList.toggle("open", isOpen);
			});

			let focusedOptionIndex = -1;

			const setFocusedOption = (index) => {
				const options = optionList.querySelectorAll(".custom-option");

				// Remove previous focus
				options.forEach((opt) => {
					opt.classList.remove("focused");
				});

				// Set new focus
				if (index >= 0 && index < options.length) {
					focusedOptionIndex = index;
					options[index].classList.add("focused");
					options[index].scrollIntoView({ block: "nearest" });
				}
			};

			customSelect.addEventListener("keydown", (e) => {
				const options = optionList.querySelectorAll(".custom-option");

				if (e.key === "Enter") {
					e.preventDefault();
					if (focusedOptionIndex >= 0) {
						// Click the focused option
						options[focusedOptionIndex].click();
					} else {
						// Open the dropdown
						const isOpen = optionList.classList.toggle("open");
						customSelect.classList.toggle("open", isOpen);
					}
				} else if (e.key === "ArrowDown") {
					e.preventDefault();
					if (!optionList.classList.contains("open")) {
						optionList.classList.add("open");
						customSelect.classList.add("open");
						focusedOptionIndex = 0;
					} else {
						focusedOptionIndex = Math.min(
							focusedOptionIndex + 1,
							options.length - 1,
						);
					}
					setFocusedOption(focusedOptionIndex);
				} else if (e.key === "ArrowUp") {
					e.preventDefault();
					if (optionList.classList.contains("open")) {
						focusedOptionIndex = Math.max(
							focusedOptionIndex - 1,
							-1,
						);
						if (focusedOptionIndex === -1) {
							optionList.classList.remove("open");
							customSelect.classList.remove("open");
						} else {
							setFocusedOption(focusedOptionIndex);
						}
					}
				}
			});

			block.addEventListener("click", (e) => {
				if (!customSelect.contains(e.target)) {
					optionList.classList.remove("open");
					customSelect.classList.remove("open");
					focusedOptionIndex = -1;
					if (!select.value.trim()) {
						wrapper.classList.remove("focused");
					}
				}
			});
		});
}
